import * as React from 'react';
import {useTranslation} from "react-i18next";
import {Dialog, DialogType, DialogFooter} from 'office-ui-fabric-react/lib/Dialog';
import {PrimaryButton, DefaultButton} from 'office-ui-fabric-react/lib/Button';
import {useId} from '@uifabric/react-hooks';
import {useModals} from "../../context/ModalContext";
import { TextField } from '@fluentui/react';

type DialogProps = {
	title: string;
	primaryText: string;
	text?: string;
	color?: string;
	primaryAction: () => void;
	open?: boolean;
	jsx?: JSX.Element;
}

const dialogStyles = {main: {maxWidth: 450}};

export const FluentDialog: React.FunctionComponent<DialogProps> = ({
 title,
 primaryText,
 text,
 primaryAction,
	jsx
}) => {
	const labelId: string = useId('dialogLabel');
	const subTextId: string = useId('subTextLabel');

	const {t} = useTranslation();

	const {closeModal} = useModals();

	const modalProps = React.useMemo(
		() => ({
			titleAriaId: labelId,
			subtitleAriaId: subTextId,
			isBlocking: false,
			styles: dialogStyles,
		}),
		[labelId, subTextId],
	);

	return (
		<>
			<Dialog
				hidden={false}
				onDismiss={closeModal}
				dialogContentProps={{
					type: DialogType.normal,
					title: title,
					closeButtonAriaLabel: 'Close',
					subText: text || "",
				}}
				modalProps={modalProps}
			>
				{jsx ? jsx: null}
				<DialogFooter>
					<PrimaryButton onClick={primaryAction} text={primaryText}/>
					<DefaultButton onClick={closeModal} text={t('cancel')}/>
				</DialogFooter>
			</Dialog>
		</>
	);
};
